export class UniqError {
  constructor(eventId, message, statusCode, url = '', data = '', errorCode = '') {
    this.id = eventId
    this.message = message
    this.statusCode = statusCode
    this.url = url
    this.data = data
    this.timestamp = new Date()
    this.errorCode = errorCode
  }
}
